import { render, staticRenderFns } from "./OrderConfirmationTicketsInfo.vue?vue&type=template&id=36b5061a&"
import script from "./OrderConfirmationTicketsInfo.vue?vue&type=script&lang=js&"
export * from "./OrderConfirmationTicketsInfo.vue?vue&type=script&lang=js&"
import style0 from "./OrderConfirmationTicketsInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports